"use client";

import { useState } from "react";
import { ChevronLeft } from "lucide-react";
import { CollapsibleSectionProps } from "@/types/booking-new.types";

export function CollapsibleSection({
  title,
  icon,
  defaultExpanded = true,
  expanded,
  onExpandedChange,
  dataSection,
  children,
}: CollapsibleSectionProps) {
  const [internalExpanded, setInternalExpanded] = useState(defaultExpanded);

  // Use external expanded state if provided, otherwise use internal state
  const isExpanded = expanded !== undefined ? expanded : internalExpanded;

  const handleToggle = () => {
    if (onExpandedChange) {
      onExpandedChange(!isExpanded);
    } else {
      setInternalExpanded(!isExpanded);
    }
  };

  return (
    <div data-section={dataSection}>
      <button
        onClick={handleToggle}
        className="w-full flex items-center justify-between p-4 hover:bg-muted/50 transition-colors"
      >
        <div className="flex items-center gap-2">
          {icon}
          <span className="font-medium">{title}</span>
        </div>
        <ChevronLeft
          className={`h-4 w-4 transition-transform ${isExpanded ? "rotate-[-90deg]" : ""}`}
        />
      </button>
      {isExpanded && <div className="p-4 pt-0">{children}</div>}
    </div>
  );
}
